import styled, { css } from 'styled-components';

export const QRInstruction = styled.div`
  margin-bottom: 1.2rem;
  color: #675d69;
  font-size: 0.98rem;
  line-height: 1.6;
  text-align: center;
`;

export const ModalButtonContent = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 0.5rem;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(61, 49, 70, 0.36);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-family: 'Inter', sans-serif;
`;

export const ModalContent = styled.div`
  background: rgba(255, 248, 242, 0.92);
  border-radius: 28px;
  box-shadow: 0 20px 48px rgba(90, 74, 94, 0.16);
  border: 1px solid rgba(118, 101, 123, 0.12);
  padding: 2.5rem 2.25rem 2.4rem 2.25rem;
  width: 420px;
  max-width: 95vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  backdrop-filter: blur(12px);
  font-family: 'Inter', sans-serif;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #5d5561;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: #3d3146;
  }
`;

export const ModalTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #3d3146;
  margin: 0 1.75rem 1rem 1.75rem;
  text-align: center;
  line-height: 1.25;
`;

export const ModalDesc = styled.p`
  font-size: 0.98rem;
  color: #675d69;
  margin: 0 0 1.5rem 0;
  text-align: center;
  line-height: 1.7;
`;

export const QRContainer = styled.div`
  background: rgba(143, 165, 149, 0.14);
  border: 1px solid rgba(118, 101, 123, 0.12);
  border-radius: 18px;
  padding: 1.5rem 1.25rem 1.25rem;
  margin-bottom: 1rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const buttonBase = css`
  width: 100%;
  padding: 0.95rem 1.5rem;
  background: linear-gradient(135deg, #8d6f92 0%, #73907a 100%);
  color: #fffaf4;
  font-size: 1.05rem;
  font-weight: 700;
  border: none;
  border-radius: 16px;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
  box-shadow: 0 16px 34px rgba(111, 86, 116, 0.18);
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 18px 36px rgba(111, 86, 116, 0.22);
  }
`;

export const ModalButton = styled.button`
  ${buttonBase}
`;

export const ModalLinkButton = styled.a`
  ${buttonBase}
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid rgba(118, 101, 123, 0.12);
  margin: 1.1rem 0 0.7rem 0;
`;

export const MetaText = styled.div`
  margin-top: 0.5rem;
  font-size: 0.8rem;
  color: #675d69;
  text-align: center;
  line-height: 1.5;
`;

export const ErrorText = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #a14d4d;
  text-align: center;
  line-height: 1.5;
`;

export const StatusText = styled.div`
  margin-top: 0.75rem;
  font-size: 0.8rem;
  color: #5f7565;
  text-align: center;
  font-weight: 600;
`;

export const TempSuccessButton = styled.button`
  position: absolute;
  bottom: 0.65rem;
  right: 0.75rem;
  background: transparent;
  border: none;
  color: #9a8f9c;
  font-size: 0.68rem;
  font-weight: 500;
  padding: 0.2rem 0.35rem;
  cursor: pointer;
  opacity: 0.65;
  transition: opacity 0.15s, color 0.15s;

  &:hover {
    opacity: 1;
    color: #7b617f;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
